// Server release date - update this when launch is confirmed
export const RELEASE_DATE = new Date('2026-04-05T18:00:00Z');

// Server info
export const SERVER_NAME = 'Lineage II Community';
export const CHRONICLE = 'Guardians';
export const DISCORD_URL = 'https://discord.gg/FkYjfFCV';
export const DOWNLOAD_OPTION_1 = 'https://yearuptemp-my.sharepoint.com/:u:/g/personal/pcunha_my_yearupunited_org/EXx-7q7z-s5KmNyct_8YhEIBXkkGrPQv1WC8bPZABU5xIA?e=liZgHf';
export const DOWNLOAD_OPTION_2 = 'https://drive.google.com/file/d/1vY2wAa8uT_m_n91TiP2R_naQa5k2H6fN/view';
